<template>
    <div class="career-detail-programs-page">
        <z-hero
            :src="detail.image?.link"
            type="image"
            title="Академия ИНК"
            :description="detail.programPeriod?.value"
        >
            <template v-slot:top>
                <z-breadcrumbs/>
            </template>
            <template v-slot:tag v-if="detail.place?.value">
                <div class="career-detail-programs-page__z-hero-tag">
                    <z-button kind="secondary" border-radius size="s">
                        {{ detail.place?.value }}
                    </z-button>
                </div>
            </template>
            <template v-slot:bottom >
                <z-button v-if="detail?.name != removeBtnOnPage"
                    tag="a"
                    kind="primary"
                    :href="detail.registrationAvailable.value !== '' ? `/career/educational-programs/registration/?program=${detail.id}` : '/news-and-media/subscription/'"
                    border-radius
                    size="m"
                >
                    {{ detail.registrationAvailable.value !== '' ? 'Подать заявку' : 'Подписаться' }}
                    <template #right>
                        <z-icon name="arrows/round-arrow-big" dir="right"></z-icon>
                    </template>
                </z-button>
                <z-button v-if="detail?.vacanciesType?.xmlId !== ''"
                    tag="a"
                    kind="secondary"
                    :href="`/career/vacancies/?type=${detail.vacanciesType.xmlId}`"
                    border-radius
                    size="m"
                >
                    К вакансиям
                    <template #right>
                        <z-icon name="arrows/round-arrow-big" dir="right"></z-icon>
                    </template>
                </z-button>
            </template>
            <template v-slot:bubble v-if="detail.programStart?.value">
                <div class="career-detail-programs-page__bubble">
                    <z-image src="/media/img/career/youth-programs/detail/bubble.png" alt="Bubble_image">
                    </z-image>
                    <p class="bubble__content">{{ detail.programStart?.value }}</p>
                </div>
            </template>
        </z-hero>
        <div class="career-detail-programs-page__wrapper">
            <div class="container">
                <p class="career-detail-programs-page__text u-bottom-margin--l u-top-margin--l"
                v-html="detail?.detailText"></p>
            </div>
            <div class="container">
                <div class="u-bottom-margin--l" v-if="detail.keyFigures && detail.keyFigures.length">
                    <z-caption tag="h2" size="lt">{{ detail.keyFiguresTitle?.value }}</z-caption>
                    <div class="career-detail-programs-page__key-indicator">
                        <div class="row">
                            <div
                                class="col-default-4 col-v-tablet-6 col-mobile-12"
                                v-for="(item, index) in detail.keyFigures"
                            >
                                <z-key-indicator
                                    :key="index"
                                    :value="item?.value ? item?.value : ''"
                                    :detail="item?.description"
                                    size="l"
                                ></z-key-indicator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <block-academies :detail="detail" :columns="2"></block-academies>

                <div
                    v-if="detail.aboutShort?.value"
                    class="career-detail-programs-page__block-check-mark block-check-mark u-bottom-margin--l u-top-margin--l u-gap--l">
                    <vue-raw :raw="detail.aboutShort?.value"></vue-raw>
                </div>

                <career-advantages :detail="detail" class="u-bottom-margin--l"></career-advantages>
            </div>

            <block-partners v-if="detail?.partners?.length" :detail="detail"></block-partners>

            <div class="container" v-if="detail?.whatYouWillStudy?.length">
                <div class="career-detail-programs-page__what-studying u-bottom-margin--l u-top-margin--l">
                    <z-caption tag="h2" size="lt">Что ты будешь изучать</z-caption>
                    <div class="row">
                        <div
                            class="col-default-4 col-v-tablet-6 col-mobile-12"
                            v-for="(item, index) in detail.whatYouWillStudy"
                        >
                            <z-card
                                :key="index"
                                href="/"
                                theme="primary"
                                :bg-image="item?.previewPicture?.link"
                                :content-data="{
                                    title: item?.name,
                                    info: item?.previewText,
                                }"
                            ></z-card>
                        </div>
                    </div>
                </div>
            </div>

            <career-graduates :detail="detail" v-if="detail.history.length"></career-graduates>

            <div class="container" v-if="detail.faq.length">
                <div class="u-bottom-margin--l u-top-margin--l">
                    <z-caption tag="h2" size="lt">Часто задаваемые вопросы</z-caption>
                    <z-accordion :set-hash="false">
                        <z-accordion-item v-for="(faq, index) in detail.faq" :key="index" :id="'acc-' + (index + 1)">
                            <template #header>
                                {{ faq?.value }}
                            </template>
                            <template #body>
                                {{ faq?.description }}
                            </template>
                        </z-accordion-item>
                    </z-accordion>
                </div>
            </div>

            <!--
            <block-admission
                :detail="detail"
                title="Поступить в&nbsp;Академию ИНК"
                description="Приходи в&nbsp;новом сезоне или&nbsp;присоединяйся сейчас!"
                bubble="true"
            >
            </block-admission>
            -->

            <div class="container u-bottom-margin--l u-top-margin--l">
                <career-contact></career-contact>
            </div>

            <div class="container other-programs-wrapper" v-if="otherPrograms && otherPrograms.length > 0">
                <div class="other-programs">
                    <template v-for="(item, index) in otherPrograms?.slice(0, 3)" :key="index">
                        <z-card
                            :href="item.detailPageUrl"
                            disable-flip
                            :is-background-image="false"
                            :image="item.image?.link"
                            theme="clipped-secondary"
                            :content-data="{
                                title: item.name,
                                tags: [item?.programStart?.value, item?.programPlace?.[0]?.value],
                            }"
                        >
                        </z-card>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useGetter } from '@/composable/useGetter'
import BlockAcademies from '@/components/BlockAcademies/BlockAcademies';
import BlockPartners from '@/components/BlockPartners/BlockPartners';
import BlockAdmission from '@/components/BlockAdmission/BlockAdmission';

const { app } = useGetter(['app'])
const detail = app.value?.components['programs-detail']?.item
const otherPrograms = app.value?.components['programs-list']

const removeBtnOnPage = 'Академия ИНК'

const store = useStore()

const setTitle = (title) => {
    store.dispatch('SetHeroTitle', title)
}

setTitle(detail.name)

</script>

<style lang="scss">
.other-programs-wrapper {
    overflow: hidden;
}
.other-programs {
    display: flex;
    gap: var(--spacer-2xl);
    overflow: auto;
    padding-bottom: var(--spacer-4xl);
    padding-top: var(--spacer-2xl);
    padding-right: 60px;
    padding-left: 60px;
    margin-right: -60px;
    margin-left: -60px;

    .z-card {
        width: 33.33%;
        max-width: 500px;
        aspect-ratio: 0;

        @include breakpoint (tablet) {
            min-width: 300px;
        }
    }
}

.career-youth-programs-detail .layout__container {
    overflow: visible;
}

.career-detail-programs-page {
    // overflow: hidden;

    &__wrapper {
        overflow: hidden;
    }

    @include breakpoint (mobile) {
        .z-button {
            width: auto;
        }
    }

    .z-hero {
        .z-button {
            width: max-content;
        }

        .z-caption:not(.z-hero__title--not-tag) {
            margin-top: var(--spacer-2xs);
        }
    }

    @media only screen and (max-width: 1359px) {
        .z-hero__wrapper > * {
            width: 70%;
        }
    }

    &__bubble {
        right: 5%;
        position: absolute;
        top: 40%;
        max-width: 278px;
        max-height: 318px;
        width: 100%;
        height: 100%;
        transform: translateY(-50%);

        p {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -60%);
            text-transform: uppercase;
            color: var(--color-white);
            font-size: 40px;
            width: 85%;
            text-align: center;

            @include breakpoint(laptop) {
                font-size: var(--typography-xl);
            }
        }

        @include breakpoint(laptop) {
            max-width: 220px;
            max-height: 250px;
            top: 50%;

            p {
                font-size: var(--typography-xl);
            }
        }

        @include breakpoint(tablet) {
            max-width: 180px;
            max-height: 210px;
        }

        @include breakpoint(mobile) {
            max-width: 120px;
            max-height: 150px;
            top: 40%;
        }
    }

    &__z-hero-tag,
    .z-hero__title--not-tag {
        margin-top: var(--spacer-4xl);
        padding-top: var(--spacer-3xl);
    }

    &__text {
        max-width: 1490px;
        font-size: var(--typography-m);

        span {
            color: var(--color-primary);
        }
    }

    &__key-indicator {
        > .row {
            margin-top: calc(var(--spacer-l) * -1);

            > [class*="col-"] {
                margin-top: var(--spacer-l);
            }
        }

        .z-key-indicator {
            max-width: 286px;
        }

        .z-key-indicator__detail {
            margin-top: var(--spacer-2xs);
            padding-top: 0;
        }

        .z-key-indicator--detail-bordered .z-key-indicator__detail {
            border: none;
        }
    }

    .block-check-mark {
        & > div {
            display: flex;
            justify-content: space-between;

            @media (max-width: 768px) {
                flex-wrap: wrap;
                justify-content: center;
                gap: 0;
            }
        }

        h4 {
            margin: 0;
        }

        &__item {
            display: flex;
            flex-direction: column;
            padding: var(--spacer-m);
            max-width: 520px;

            @media (max-width: 768px) {
                align-items: center;
                text-align: center;

                p {
                    text-align: center;
                }
            }
        }
    }

    .z-accordion-item-header__text {
        color: var(--color-table-text-totall);
    }

    .z-accordion-item-header,
    .z-accordion-panel {
        background: transparent;
    }
}
</style>
